import React from "react";
import Navigation from "../components/Navigation";
import AboutMission from "../components/AboutMission";
import TeamSection from "../components/TeamSection";
import WhyChooseUs from "../components/WhyChooseUs";
import Footer from "../components/Footer";

const AboutPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <AboutMission />
      <TeamSection />
      <WhyChooseUs />
      <Footer />
    </div>
  );
};

export default AboutPage;
